import { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import api from '../../services/Api';

const COLORS = ['#0E5FD9', '#E84646', '#FF9500', '#4CAF50', '#9C27B0', '#795548', '#607D8B'];

const MostVisitedPages = () => {
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    api
      .get('/analytics/pages?limit=20')
      .then(res => {
        const processedData = processPageData(res.data);
        setPieData(processedData.slice(0, 3));
      })
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  const normalizeUrl = url => {
    if (url.startsWith('/v1/')) {
      return url.substring(3);
    }
    return url;
  };

  const processPageData = data => {
    if (!data || data.length === 0) return [];

    const pageMap = new Map();

    data.forEach(pageData => {
      const normalizedUrl = normalizeUrl(pageData.page);

      if (pageMap.has(normalizedUrl)) {
        const existingEntry = pageMap.get(normalizedUrl);
        existingEntry.visits += pageData.visits;
      } else {
        pageMap.set(normalizedUrl, {
          _id: normalizedUrl,
          page: normalizedUrl,
          visits: pageData.visits,
          uniqueVisitors: pageData.uniqueVisitors || 0,
        });
      }
    });

    const mergedData = Array.from(pageMap.values()).sort((a, b) => b.visits - a.visits);

    return mergedData.map((pageData, index) => {
      return {
        _id: pageData._id,
        name: formatPageName(pageData.page),
        value: pageData.visits,
        color: COLORS[index % COLORS.length],
        rawPage: pageData.page,
      };
    });
  };

  const formatPageName = pagePath => {
    if (!pagePath) return 'Unknown';

    if (pagePath === '/') return 'Home';

    if (pagePath.includes('/user/by-any/_id/')) {
      return 'User Profile';
    }

    if (pagePath.includes('/industryListing/industries')) {
      return 'Industry';
    }

    if (pagePath.includes('/business/application/')) {
      return 'Requests';
    }

    if (pagePath.includes('/business/') && !pagePath.includes('/application/')) {
      return 'Business';
    }

    return pagePath
      .split('/')
      .filter(part => part.length > 0)
      .map(part => part.charAt(0).toUpperCase() + part.slice(1).replace(/[-_]/g, ' '))
      .join(' - ');
  };

  return (
    <div className="h-[416px] flex flex-col font-nohemi">
      <div className="flex flex-row justify-between px-2 border-b-2 border-[#E5E7E8]">
        <div className="m-2">
          <p className="mt-2 text-base font-normal font-nohemi">Most Visited Page</p>
        </div>
        <div className="m-2 bg-[#F5F6F7] rounded">
          <p className="font-nohemi font-normal text-sm text-[#4A5154] p-2">This month</p>
        </div>
      </div>

      <div className="w-full h-[232px] flex justify-center items-center">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieData}
              cx="50%"
              cy="50%"
              innerRadius={40}
              outerRadius={60}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value">
              {pieData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="h-[134px] overflow-auto">
        <table className="w-full font-sans table-auto rounded-xl">
          <thead>
            <tr className="text-[11px] uppercase text-[#4A5154] bg-[#F5F6F7]">
              <th className="py-2 pl-4 font-light text-left">Page Name</th>
              <th className="p-2 font-light text-left text-nowrap">Total Users</th>
              <th className="p-2 font-light text-left text-nowrap">Bounce Rate</th>
            </tr>
          </thead>
          <tbody className="bg-[#FFFFFF]">
            {pieData.map(item => (
              <tr key={item._id}>
                <td className="font-public text-xs px-4 py-1 font-medium text-[#191B1C] text-nowrap">
                  <span
                    className="inline-block w-2 h-2 rounded-full"
                    style={{ backgroundColor: item.color }}></span>{' '}
                  {item.name}
                </td>
                <td className="font-public text-[10px] p-2 font-light text-[#4A5154]">
                  {item.value.toLocaleString()}
                </td>
                <td className="font-public text-[10px] p-2 font-light text-[#0FAF62]">
                  {item.value === 0 ? 'N/A' : ((0 / item.value) * 100).toFixed(2) + '%'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MostVisitedPages;
